import { TabPanel, TabView } from 'primereact/tabview';
import React, {useState } from 'react';

import { CaDashboard } from '../../features/correctiveActions/dashboardCorrectiveAction/CaDashboard';
import { CaMangerTl } from '../../features/correctiveActions/managerTlViewSearch/CaMangerTlView';
import { caDetails } from '../../features/correctiveActions/type';
import { AssignmentTabIndex } from '../../utils/typeConstants';

interface PendingApprovalsProps {
    pendingApprovals?: any;
}
export const PendingApprovals = ({pendingApprovals}:PendingApprovalsProps) => {
    const [activeIndex, setActiveIndex] = useState<number>(AssignmentTabIndex.Dashboard);
    const [selectedEmployee, setSelectedEmployee] = useState<caDetails | undefined>();
    const [via, setVia] = useState<string>('tab');

    return (
        <div>
            <div className="card shadow bg-body rounded mt-4 border-0">
                <div className="card-body">
                    <div className="row">
                        <h5>Needs Action</h5>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <TabView
                                activeIndex={activeIndex}
                                onTabChange={(e) => {
                                    // setSelectedEmployee(undefined)
                                    setActiveIndex(e.index);
                                }}
                            >
                                <TabPanel header="Dashboard">
                                    <div className="card border-0 p-3 ps-0">
                                        <div className="card-body p-0">
                                            <CaDashboard
                                                fromPage={'PendingApprovals'}
                                                pendingApprovalsData={pendingApprovals}
                                                setVia={setVia}
                                                setSelectedEmployee={setSelectedEmployee}
                                                setActiveIndex={setActiveIndex}
                                            />
                                        </div>
                                    </div>
                                </TabPanel>
                                {activeIndex === AssignmentTabIndex.View - 1 && (
                                    <TabPanel header="View">
                                        <div className="card border-0 p-3 ps-0">
                                            <div className="card-body p-0">
                                                <CaMangerTl
                                                    setActiveIndex={setActiveIndex}
                                                    type={'view'}
                                                    getDetails
                                                    selectedEmployee={selectedEmployee}
                                                    view
                                                />
                                            </div>
                                        </div>
                                    </TabPanel>
                                )}
                                {(activeIndex === AssignmentTabIndex.Updates - 1)&& (
                                    <TabPanel header="Update">
                                        <div className="card border-0 p-3 ps-0">
                                            <div className="card-body p-0">
                                                <CaMangerTl
                                                    setActiveIndex={setActiveIndex}
                                                    type= {'update'}
                                                    getDetails
                                                    via={via}
                                                    selectedEmployee={selectedEmployee}
                                                    view={false}
                                                />
                                            </div>
                                        </div>
                                    </TabPanel>
                                )}
                                 {(activeIndex === AssignmentTabIndex.Acknowledged -1) && <TabPanel header="Update">
                                    <div className="card border-0 p-3 ps-0">
                                        <div className="card-body p-0">
                                            <CaMangerTl setActiveIndex={setActiveIndex} 
                                            type = {'ack'} 
                                            getDetails via={via} 
                                            selectedEmployee={selectedEmployee} 
                                            view />
                                        </div>
                                    </div>
                                </TabPanel>}
                            </TabView>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
